/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Why_Testimonial_1_QuoteInputs */

const es_home_why_testimonial_1_quote = /** @type {(inputs: Home_Why_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes de Nexy, buscar información era una expedición. Ahora es una conversación.`)
};

const en_home_why_testimonial_1_quote = /** @type {(inputs: Home_Why_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before Nexy, searching for information was an expedition. Now it's a conversation.`)
};

/**
* | output |
* | --- |
* | "Before Nexy, searching for information was an expedition. Now it's a conversation." |
*
* @param {Home_Why_Testimonial_1_QuoteInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_why_testimonial_1_quote = /** @type {((inputs?: Home_Why_Testimonial_1_QuoteInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Why_Testimonial_1_QuoteInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_why_testimonial_1_quote(inputs)
	return en_home_why_testimonial_1_quote(inputs)
});
export { home_why_testimonial_1_quote as "home.why.testimonial_1_quote" }